import { createAsyncThunk } from '@reduxjs/toolkit';
import { ApplicationDataApi } from 'api/ApplicationDataApi';

import { ErrorResponse } from './ErrorResponse';

export const createGetAdditionalFundsThunk = (api: ApplicationDataApi) =>
  createAsyncThunk('/application/additionalFunds', async (applicationId: string, thunkApi) => {
    try {
      return await api.getAdditionalFunds(applicationId);
    } catch (error: unknown) {
      return thunkApi.rejectWithValue((error as ErrorResponse).response.data);
    }
  });
